<div class="p-5">
  <div class="flex justify-between items-center">
    <div class="text-lg text-gray-700 font-bold">Itinerário</div>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="mt-3 grid grid-cols-2 gap-x-6 gap-y-1 text-sm text-gray-700">
    <div><b>TG:</b> {{ item.codigoTg || '-' }}</div>
    <div><b>OS:</b> {{ item.codigoOs || '-' }}</div>
  </div>

  @if (itinerario.length) {
  <div class="mt-4 flex flex-col gap-3 max-h-[60vh] overflow-y-auto">
    @for (trecho of itinerario; track $index) {
    <div class="border-l-4 border-blue-700 pl-3 text-sm text-gray-700">
      <div class="font-bold">{{ $index + 1 }}. {{ trechoLabel(trecho.trecho) }}
        @if (trecho.localParada) { <span class="font-normal">— {{ trecho.localParada }}</span> }
      </div>
      <div>{{ trecho.enderecoCompleto || '-' }}</div>
      @if (trecho.horaParada || trecho.tempoPermanencia) {
      <div>
        @if (trecho.horaParada) { <b>Hora: </b>{{ trecho.horaParada }} }
        @if (trecho.tempoPermanencia) { <b>Permanência: </b>{{ trecho.tempoPermanencia }} }
      </div>
      }
      @if (trecho.atividades) {
      <div><b>Atividades: </b>{{ trecho.atividades }}</div>
      }
    </div>
    }
  </div>
  } @else {
  <div class="mt-4 text-sm text-gray-700">Nenhum itinerário disponível para esta OS.</div>
  }
</div>
